import { GridColumns } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';
import { booleanCell } from '../cells/boolean-cell';
import { dateCell } from '../cells/date-cell';
import {
  dateFilterOperators,
  filterOperators,
  numberFilterOperators
} from './../../../../constants';

export function StockQuantityLocationColumns(isAdmin = false): GridColumns {
  const { t } = useTranslation();
  const prefix = 'pages.locations.columns';

  const columns: GridColumns = [
    {
      field: 'product_code',
      headerName: t(`${prefix}.product_code`),
      width: 150,
      type: 'text',
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'product_description',
      headerName: t(`${prefix}.product_description`),
      width: 200,
      type: 'text',
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'quantity',
      headerName: t(`${prefix}.quantity`),
      width: 100,
      type: 'number',
      editable: isAdmin,
      filterOperators: numberFilterOperators,
      renderCell: baseCell
    },
    {
      field: 'product_batch',
      headerName: t(`${prefix}.product_batch`),
      width: 150,
      type: 'text',
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'expiration_date',
      headerName: t(`${prefix}.expiration_date`),
      width: 150,
      type: 'date',
      filterOperators: dateFilterOperators,
      renderCell: dateCell
    },
    {
      field: 'discounted',
      headerName: t(`${prefix}.discounted`),
      width: 100,
      type: 'boolean',
      renderCell: booleanCell(t)
    }
  ];
  return columns;
}
